module.exports = __webpack_public_path__ + "static/home-a5895d90fbd710ffbbcc5cc05edefe4c.jpg";